import { api } from './cliente.js';

export type TipoIniciativa = 'implementacao' | 'migracao' | 'melhoria' | 'pesquisa';
export type EstadoBlueprint = 'Rascunho' | 'Publicado' | 'Descontinuado';

export interface Blueprint {
  id: string;
  nome: string;
  tipoIniciativa: TipoIniciativa;
  versao: number;
  estado: EstadoBlueprint;
  criadoPor: string;
  criadoEm: string;
}

export type TipoCriterioGate = 'artefato_entregue' | 'aprovacao_manual' | 'metrica_atingida' | 'atividades_concluidas';

export interface CriterioGate {
  descricao: string;
  tipo: TipoCriterioGate;
  obrigatorio: boolean;
}

export interface FaseBlueprint {
  ordem: number;
  nome: string;
  duracaoEstimadaDias: number | null;
  permiteOverlapProxima: boolean;
  skills: string[];
  marcos: string[];
  artefatos: string[];
  atividadesPadrao: { nome: string; esforcoEstimadoH: number; skillPrincipal: string | null }[];
  criteriosGate: CriterioGate[];
}

export interface BlueprintComFases extends Blueprint {
  fases: FaseBlueprint[];
}

export interface CriarBlueprintInput {
  nome: string;
  tipoIniciativa: TipoIniciativa;
  fases: FaseBlueprint[];
}

export type StatusDiffFase = 'adicionada' | 'removida' | 'inalterada' | 'alterada';
export interface DiffFase {
  nome: string;
  status: StatusDiffFase;
}
export interface Diff {
  fases: DiffFase[];
}

export const blueprintsApi = {
  listarPublicados: (tipo?: TipoIniciativa) => api.get<Blueprint[]>(`/blueprints${tipo ? `?tipo=${tipo}` : ''}`),
  buscar: (id: string) => api.get<BlueprintComFases>(`/blueprints/${id}`),
  criar: (input: CriarBlueprintInput) => api.post<{ id: string }>('/blueprints', input),
  clonar: (id: string) => api.post<{ id: string }>(`/blueprints/${id}/clonar`),
  publicar: (id: string) => api.post(`/blueprints/${id}/transicoes`, { evento: 'publicar' }),
  diff: (idA: string, idB: string) => api.get<Diff>(`/blueprints/diff/${idA}/${idB}`),
};
